/*tslint:disable:max-line-length*/
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { GaugeModule } from 'angular-gauge';
import { NgxEchartsModule } from 'ngx-echarts';

import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
const SocketConfig: SocketIoConfig = {
  url: window.location.href.substr(0, window.location.href.lastIndexOf(window.location.pathname)), // url as protokoll + url + port
  options: {}
};

import { AppComponent } from './app.component';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatGridList,
  MatGridTile,
  MatIconModule,
  MatMenuModule,
  MatToolbarModule,
  MatTableModule,
  MatProgressSpinnerModule } from '@angular/material';
import {MatBadgeModule} from '@angular/material/badge';
import { AppRoutingModule } from './app-routing.module';
import { HomeComponent } from './home/home.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardQualityComponent } from './dashboard/machines/dashboard-quality/dashboard-quality.component';
import { DashboardMarkingComponent } from './dashboard/machines/dashboard-marking/dashboard-marking.component';
import { DashboardPreparationComponent } from './dashboard/machines/dashboard-preparation/dashboard-preparation.component';
import { DashboardWarehouseBecherComponent } from './dashboard/warehouse/dashboard-warehouse-becher/dashboard-warehouse-becher.component';
import { DashboardWarehouseZutatenComponent } from './dashboard/warehouse/dashboard-warehouse-zutaten/dashboard-warehouse-zutaten.component';
import { DashboardWarehouseCteileComponent } from './dashboard/warehouse/dashboard-warehouse-cteile/dashboard-warehouse-cteile.component';
import { AmpelComponent } from './widgets/ampel/ampel.component';
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    DashboardComponent,
    DashboardQualityComponent,
    DashboardMarkingComponent,
    DashboardPreparationComponent,
    MatGridList,
    MatGridTile,
    AmpelComponent,
    DashboardWarehouseBecherComponent,
    DashboardWarehouseZutatenComponent,
    DashboardWarehouseCteileComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatTableModule,
    MatButtonModule,
    MatBadgeModule,
    MatCardModule,
    MatCheckboxModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    GaugeModule.forRoot(),
    NgxEchartsModule,
    SocketIoModule.forRoot(SocketConfig),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
